export enum GuardServiceAction {
	DELETE = '_ws-framework.guard.delete-action',
	SAVE = '_ws-framework.guard.save-action',
}
